import * as React from 'react';

import AboutSection from 'bundles/about/components/AboutSection';
import type { PageContent } from 'bundles/about/components/useAboutPageContentfulData';

type Props = {
  pageContent?: PageContent | null;
};

export const AboutSections = ({ pageContent }: Props) => {
  if (!pageContent?.slug) {
    return null;
  }

  const {
    title1,
    title1ContentCollection,
    title2,
    title2ContentCollection,
    title3,
    title3ContentCollection,
    title4,
    title4ContentCollection,
    title5,
    title5ContentCollection,
    title6,
    title6ContentCollection,
  } = pageContent || {};

  return (
    <>
      {title1 && title1ContentCollection && <AboutSection title={title1} content={title1ContentCollection.items} />}
      {title2 && title2ContentCollection && <AboutSection title={title2} content={title2ContentCollection.items} />}
      {title3 && title3ContentCollection && <AboutSection title={title3} content={title3ContentCollection.items} />}
      {title4 && title4ContentCollection && <AboutSection title={title4} content={title4ContentCollection.items} />}
      {title5 && title5ContentCollection && <AboutSection title={title5} content={title5ContentCollection.items} />}
      {title6 && title6ContentCollection && <AboutSection title={title6} content={title6ContentCollection.items} />}
    </>
  );
};

export default AboutSections;
